/**
 * 도메인 엔티티 기본 클래스
 * DDD의 Entity 개념 구현
 */
export abstract class Entity<T> {
  protected readonly _id: T;
  protected _createdAt: Date;
  protected _updatedAt: Date;

  constructor(id: T) {
    this._id = id;
    this._createdAt = new Date();
    this._updatedAt = new Date();
  }

  get id(): T {
    return this._id;
  }

  get createdAt(): Date {
    return this._createdAt;
  }

  get updatedAt(): Date {
    return this._updatedAt;
  }

  /**
   * 엔티티 동등성 비교
   * ID가 같으면 같은 엔티티로 간주
   */
  equals(entity?: Entity<T>): boolean {
    if (entity === null || entity === undefined) {
      return false;
    }

    if (this === entity) {
      return true;
    }

    if (!(entity instanceof Entity)) {
      return false;
    }

    return this._id === entity._id;
  }

  /**
   * 엔티티 업데이트 시각 갱신
   */
  protected touch(): void {
    this._updatedAt = new Date();
  }
}